<i
  *ngFor="let star of fullStars"
  class="lx-star lx-star--full"
  [class.lx-star--small]="variant === 'small'"
  [class.lx-star--normal]="variant === 'normal'"
  [class.lx-star--large]="variant === 'large'"
  style="--star-full-background: {{ color }}"
></i>
<i
  class="lx-star lx-star--half"
  [class.lx-star--small]="variant === 'small'"
  [class.lx-star--normal]="variant === 'normal'"
  [class.lx-star--large]="variant === 'large'"
  style="--star-half-gradient: {{ halfStarGradient }}"
  *ngIf="hasHalfStar"
></i>
<i
  *ngFor="let star of emptyStars"
  class="lx-star"
  [class.lx-star--small]="variant === 'small'"
  [class.lx-star--normal]="variant === 'normal'"
  [class.lx-star--large]="variant === 'large'"
></i>
